import { validators } from './validators';
export var validate = function (validatorNames, value) {
    return (validatorNames.length
        ? validatorNames.map(function (name) { return validators[name](value); })
        : [{ result: true, message: null }]).reduce(function (prev, curr) { return (prev.result && !curr.result ? curr : prev); });
};
